export const CONTENT_WIDTH = { xs: 1000, lg: 1180, xl: 1360 };

export const CONTENT_WIDTH_NARROW = 460;

export const CONTENT_PADDING = { xs: 4, md: 8 };
